import {
  SET_PERMISSION_STATUS,
  CHECK_PERMISSIONS_LOADING,
  CHECK_PERMISSIONS_RETAILER,
} from '../constants/checkPermissionsTypes';

const initialState = {
  status: null,
  isLoading: true,
  administration: false,
  dropship: false,
  replenish: false,
};

const checkPermissions = (state = initialState, action) => {
  switch (action.type) {
    case CHECK_PERMISSIONS_LOADING:
      return {
        ...state,
        isLoading: action.payload,
        status: null,
      };
    case SET_PERMISSION_STATUS:
      return {
        ...state,
        status: action.payload.status,
        isLoading: false,
      };
    case CHECK_PERMISSIONS_RETAILER:
      const permissions = action.payload;
      const dropship = permissions.hasOwnProperty('dropship') ? permissions.dropship : state.dropship;
      const replenish = permissions.hasOwnProperty('replenish') ? permissions.replenish : state.replenish;
      const administration = permissions.hasOwnProperty('administration')
        ? permissions.administration
        : state.administration;

      return {
        ...state,
        dropship,
        replenish,
        administration,
      };

    default:
      break;
  }

  return state;
};

export default checkPermissions;
